import * as actionTypes from "./actionTypes";
import { LOGOUT_USER } from "../user/actionTypes";

const initialState = {
  resetPassword: { success: false, error: null, loading: false },
  customerList: { customers: [], total: 0, pageSize: 0, error: null, loading: false },
  activeCustomer: { customer: null, error: null, loading: false },
  customerSellList: { sells: [], total: 0, pageSize: 0, error: null, loading: false },
  bulkLoad: { value: undefined, loading: false, error: undefined }
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_CUSTOMERS:
      return {
        ...state,
        customerList: {
          ...state.customerList,
          error: null,
          loading: true
        }
      };

    case actionTypes.FETCH_CUSTOMERS_SUCCESS:
      return {
        ...state,
        customerList: {
          customers: action.payload.customers,
          total: action.payload.total,
          pageSize: action.payload.pageSize,
          error: null,
          loading: false
        }
      };

    case actionTypes.FETCH_CUSTOMERS_FAILURE:
      return {
        ...state,
        customerList: {
          customers: [],
          total: 0,
          pageSize: 0,
          error: action.payload.error,
          loading: false
        }
      };

    case actionTypes.RESET_CUSTOMERS:
      return { ...state, customerList: initialState.customerList };

    // BY PREFIX

    case actionTypes.FETCH_CUSTOMERS_BY_PREFIX:
      return {
        ...state,
        customerList: {
          ...state.customerList,
          error: null,
          loading: true
        }
      };

    case actionTypes.FETCH_CUSTOMERS_BY_PREFIX_SUCCESS:
      return {
        ...state,
        customerList: {
          customers: action.payload.customers,
          // total: action.payload.total,
          // pageSize: action.payload.pageSize,
          error: null,
          loading: false
        }
      };

    case actionTypes.FETCH_CUSTOMERS_BY_PREFIX_FAILURE:
      return {
        ...state,
        customerList: {
          customers: [],
          total: 0,
          pageSize: 0,
          error: action.payload.error,
          loading: false
        }
      };

    case actionTypes.RESET_CUSTOMERS_BY_PREFIX:
      return { ...state, customerList: initialState.customerList };

    // BULK LOAD
    case actionTypes.BULK_LOAD_CUSTOMERS:
      return {
        ...state,
        bulkLoad: { value: undefined, loading: true, error: undefined }
      };

    case actionTypes.BULK_LOAD_CUSTOMERS_SUCCESS:
      return {
        ...state,
        bulkLoad: { value: action.payload.value, loading: false, error: undefined }
      };

    case actionTypes.BULK_LOAD_CUSTOMERS_FAILURE:
      return {
        ...state,
        bulkLoad: { value: undefined, loading: false, error: action.payload.error }
      };

    case actionTypes.BULK_LOAD_CUSTOMERS_RESET:
      return {
        ...state,
        bulkLoad: initialState.bulkLoad
      };

    // Reset password
    case actionTypes.CUSTOMER_RESET_PASSWORD:
      return { ...state, resetPassword: { success: false, error: null, loading: true } }

    case actionTypes.CUSTOMER_RESET_PASSWORD_SUCCESS:
      return { ...state, resetPassword: { success: true, error: null, loading: false } }

    case actionTypes.CUSTOMER_RESET_PASSWORD_FAILURE:
      return { ...state, resetPassword: { success: false, error: action.payload.error, loading: false } }

    case actionTypes.RESET_CUSTOMER_RESET_PASSWORD:
      return { ...state, resetPassword: initialState.resetPassword }

    // By Prefix

    case actionTypes.FETCH_CUSTOMER:
      return { ...state, activeCustomer: { customer: null, error: null, loading: true } };

    case actionTypes.FETCH_CUSTOMER_SUCCESS:
      return {
        ...state,
        activeCustomer: { customer: action.payload.customer, error: null, loading: false }
      };

    case actionTypes.FETCH_CUSTOMER_FAILURE:
      return {
        ...state,
        activeCustomer: { customer: null, error: action.payload.error, loading: false }
      };

    case actionTypes.RESET_CUSTOMER:
      return { ...state, activeCustomer: initialState.activeCustomer };

    case actionTypes.FETCH_CUSTOMER_SELLS:
      return {
        ...state,
        customerSellList: {
          ...state.customerSellList,
          error: null,
          loading: true
        }
      };

    case actionTypes.FETCH_CUSTOMER_SELLS_SUCCESS: {
      return {
        ...state,
        customerSellList: {
          sells: action.payload.sells,
          total: action.payload.total,
          pageSize: action.payload.pageSize,
          error: null,
          loading: false
        }
      };
    }

    case actionTypes.FETCH_CUSTOMER_SELLS_FAILURE:
      return {
        ...state,
        customerSellList: {
          sells: [],
          total: 0,
          pageSize: 0,
          error: action.payload.error,
          loading: false
        }
      };

    case actionTypes.RESET_CUSTOMER_SELLS:
      return { ...state, customerSellList: initialState.customerSellList };

    case LOGOUT_USER:
      return initialState;

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/store/customer/reducer.js